import store from "../config/configureStore";

const SHOW_SPINNER = "UI/SHOW_SPINNER";
const HIDE_SPINNER = "UI/HIDE_SPINNER";

// Drawers
const SET_CIRCULAR_LOADING = "SET_CIRCULAR_LOADING";
const SET_GLOBAL_CIRCULAR_LOADING = "SET_GLOBAL_CIRCULAR_LOADING";

export const SET_NAVIGATION_DRAWER_MOBILE_STATE =
  "UI/SET_NAVIGATION_DRAWER_MOBILE_STATE";

export const showSpinner = () => {
  return (dispatch) => {
    dispatch({ type: SHOW_SPINNER });
  };
};

export const hideSpinner = () => {
  return (dispatch) => {
    dispatch({ type: HIDE_SPINNER });
  };
};

export const setNavigationDrawerMobileState = (state) => {
  const currentState = store.store.getState().ui.navigationDrawerMobileState;
  return async (dispatch) => {
    if (state) {
      dispatch({ type: SET_NAVIGATION_DRAWER_MOBILE_STATE, payload: state });
    } else {
      dispatch({
        type: SET_NAVIGATION_DRAWER_MOBILE_STATE,
        payload: !currentState,
      });
    }
  };
};
export const setCircularLoading = (flag) => {
  return async (dispatch) => {
    return dispatch({ type: SET_CIRCULAR_LOADING, payload: flag });
  };
};
export const setGlobalCircularLoading = (flag) => {
  return async (dispatch) => {
    return dispatch({ type: SET_GLOBAL_CIRCULAR_LOADING, payload: flag });
  };
};
export default function reducer(
  state = {
    showSpinner: false,
    navigationDrawerMobileState: false,
    circularLoading: false,
    globalCircularLoading: false,
  },
  action
) {
  switch (action.type) {
    case SHOW_SPINNER:
      return { ...state, showSpinner: true };
    case HIDE_SPINNER:
      return { ...state, showSpinner: false };
    case SET_NAVIGATION_DRAWER_MOBILE_STATE:
      return {
        ...state,
        navigationDrawerMobileState: action.payload,
      };
    case SET_CIRCULAR_LOADING:
      return { ...state, circularLoading: action.payload };
    case SET_GLOBAL_CIRCULAR_LOADING:
      return { ...state, globalCircularLoading: action.payload };
    default:
      break;
  }
  return state;
}
